import { BOOKING_PRE_PAYMENT, BOOKING_STATUS, MAXIMUM_APEPAGO_LOAN_AMOUNT } from "../constants"
import { isBookingR2R } from "./booking"

export const getPricing = (property, booking, hasCounteroffer) => {
  const { consumptionCosts = 0, fee_percentage = 0 } = property
  const { extra_fee, prop } = booking
  const isBookingPending = booking.status === BOOKING_STATUS.PENDING
  const price = hasCounteroffer ? booking.counter_offer : isBookingPending ? booking.tenant_proposal : property.price
  
  const monthly = hasCounteroffer
    ? booking.counter_offer
    : parseFloat(prop?.tari || 0) + parseFloat(price) + parseFloat(consumptionCosts || 0)
  const monthlyMinusPrePayment = monthly - BOOKING_PRE_PAYMENT
  const upfrontFee = extra_fee
  const monthly_fee = (fee_percentage / 100) * monthly;

  const rawDeposit = isBookingR2R(booking)
    ? monthly * booking.deposit
    : (price - (monthly_fee || 0)) * booking.deposit

  const deposit = Math.round(rawDeposit * 100) / 100

  const canHaveFlexibility = MAXIMUM_APEPAGO_LOAN_AMOUNT > upfrontFee
  return { price, monthly, monthlyMinusPrePayment, upfrontFee, deposit, canHaveFlexibility }
}